import { AccessFunction } from 'data/accessFunction/accessFunction.types';

export const mockAccessFunctionsUPF: AccessFunction[] = [
  {
    name: 'AF Name 1 UPF',
    id: 'id1UPF',
    tag: 'ERK_UPF',
    dxOwner: 'dxOwner1',
    dxAccess: 'dxAccess1',
    contact: { id: 'contactId1', name: 'contact1' },
    insideNat: false,
    liInterface: 'INI1',
    model: 'model1',
    preprovisioningLead: 'preprovisioningLead1',
    serialNumber: 'serialNumber1',
    timeZone: 'timeZone1',
    type: 'ERK_UPF',
    version: 'version1',
    latitude: 'latitude1',
    longitude: 'longitude1',
    status: 'ACTIVE',
  },
  {
    name: 'AF Name 2 UPF',
    id: 'id2UPF',
    tag: 'ERK_UPF',
    dxOwner: 'dxOwner1',
    dxAccess: 'dxAccess1',
    contact: { id: 'contactId1', name: 'contact1' },
    insideNat: false,
    liInterface: 'INI1',
    model: 'model1',
    preprovisioningLead: 'preprovisioningLead1',
    serialNumber: 'serialNumber1',
    timeZone: 'timeZone1',
    type: 'ERK_UPF',
    version: 'version1',
    latitude: 'latitude1',
    longitude: 'longitude1',
    status: 'ACTIVE',
  },
];

export const mockAccessFunctionsSMF: AccessFunction[] = [
  {
    name: 'AF Name 1 SMF',
    id: 'id1SMF',
    tag: 'ERK_SMF',
    dxOwner: 'dxOwner1',
    dxAccess: 'dxAccess1',
    contact: { id: 'contactId1', name: 'contact1' },
    insideNat: false,
    liInterface: 'INI1',
    model: 'model1',
    preprovisioningLead: 'preprovisioningLead1',
    serialNumber: 'serialNumber1',
    timeZone: 'timeZone1',
    type: 'ERK_SMF',
    version: 'version1',
    latitude: 'latitude1',
    longitude: 'longitude1',
    status: 'ACTIVE',
  },
  {
    name: 'AF Name 2 SMF',
    id: 'id2SMF',
    tag: 'ERK_SMF',
    dxOwner: 'dxOwner1',
    dxAccess: 'dxAccess1',
    contact: { id: 'contactId1', name: 'contact1' },
    insideNat: false,
    liInterface: 'INI1',
    model: 'model1',
    preprovisioningLead: 'preprovisioningLead1',
    serialNumber: 'serialNumber1',
    timeZone: 'timeZone1',
    type: 'ERK_SMF',
    version: 'version1',
    latitude: 'latitude1',
    longitude: 'longitude1',
    status: 'ACTIVE',
  },
];

export const mockGenericAccessFunction: AccessFunction = {
  id: 'Q0FTQS1TTUY',
  name: '',
  type: '',
  tag: '',
  mdf2NodeName: undefined,
  mdf3NodeName: undefined,
  ccnodename: undefined,
  country: 'US',
  stateName: '',
  city: '',
  provisioningInterfaces: [
      {
          id: 'Q0FTQS1TTUYjMSNJTkkx',
          name: 'Q0FTQS1TTUYjMSNJTkkx',
          options: [
              {
                  key: 'afid',
                  value: 'CASA-SMF'
              },
              {
                  key: 'ifid',
                  value: '1'
              },
              {
                  key: 'litype',
                  value: 'INI1'
              },
              {
                  key: 'reqState',
                  value: 'ACTIVE'
              },
              {
                  key: 'state',
                  value: 'INACTIVE'
              },
              {
                  key: 'ownnetid',
                  value: 'QVVUTy1YQ1A'
              },
              {
                  key: 'appProtocol',
                  value: 'CASA_5GSMF'
              },
              {
                  key: 'version',
                  value: '1.7.1'
              },
              {
                  key: 'traceLevel',
                  value: '1'
              },
              {
                  key: 'destIPAddr',
                  value: '0.0.0.0'
              },
              {
                  key: 'destPort',
                  value: '0'
              },
              {
                  key: 'role',
                  value: 'CLIENT'
              },
              {
                  key: 'dscp',
                  value: '0'
              },
              {
                  key: 'transport',
                  value: 'HTTP'
              },
              {
                  key: 'uri',
                  value: 'http://10.0.162.102'
              },
              {
                  key: 'tpkt',
                  value: 'N'
              },
              {
                  key: 'secinfoid',
                  value: 'Tk9ORQ'
              },
              {
                  key: 'encryptKey',
                  value: '*****'
              },
              {
                  key: 'encryptMethod',
                  value: 'NONE'
              },
              {
                  key: 'sshInfoId',
                  value: ''
              },
              {
                  key: 'errormsg',
                  value: ''
              },
              {
                  key: 'owner',
                  value: 'sysadm'
              },
              {
                  key: 'group',
                  value: 'lis'
              },
              {
                  key: 'access',
                  value: 'GG'
              },
              {
                  key: 'httpversion',
                  value: 'HTTP/2'
              },
              {
                  key: 'keepaliveinterval',
                  value: '60'
              },
              {
                  key: 'tls_alpn',
                  value: 'Y'
              },
              {
                  key: 'mdf2NodeName',
                  value: 'MDF2'
              },
              {
                  key: 'mdf3NodeName',
                  value: 'MDF3'
              }
          ]
      }
  ],
  dataInterfaces: [],
  contentInterfaces: [],
  afOptions: [],
  dxOwner: 'dummy_dxOwner',
  dxAccess: 'dummy_dxAccess',
  contact: {
    id: '',
    name: ''
  },
  insideNat: false,
  liInterface: 'ALL',
  model: '',
  preprovisioningLead: '000:00',
  serialNumber: '',
  timeZone: 'America/Los_Angeles',
  contentDeliveryVia: 'directFromAF',
  dataDeliveryVia: 'ss8Distributor',
  deliveryFormat: '',
  description: '',
  version: '',
}

// eslint-disable-next-line import/prefer-default-export
export const mockAccessFunctions: AccessFunction[] = [
  ...mockAccessFunctionsUPF,
  ...mockAccessFunctionsSMF,
];
